var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPieChartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2216_629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6702 0.463379C11.4979 0.463379 0 11.9612 0 26.1336C0 40.3059 11.4979 51.8037 25.6702 51.8037C32.7623 51.8037 39.1739 48.9263 43.8184 44.2818L25.6702 26.1336V0.463379Z",
    fill: "#3B82C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3421 26.1338H25.6719L43.8201 44.282C48.4646 39.6375 51.3421 33.2259 51.3421 26.1338Z",
    fill: "#8CBFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3421 26.1336C51.3421 23.9008 51.0316 21.7398 50.4824 19.6623C48.2377 10.9941 41.5874 4.10496 33.0386 1.54988C30.7104 0.845447 28.2389 0.463379 25.6719 0.463379V26.1336H51.3421Z",
    fill: "#2B6299"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2216_629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.3404,
    height: 51.3404,
    fill: "white",
    transform: "translate(0 0.463379)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartIcon);
export default __webpack_public_path__ + "static/media/pie_chart_icon.955fd957.svg";
export { ForwardRef as ReactComponent };